
interface AgenticCapability {
  title: string;
  description: string;
}

const AgenticCapabilitiesSection = () => {
  const agenticCapabilities: AgenticCapability[] = [
    {
      title: "Autonomous Investigation with AuraXP Reasoning",
      description: "Our Agentic AI automatically performs autonomous investigation of security events, examining patterns, context, and threat intelligence to quickly determine severity and potential impact with advanced reasoning capabilities."
    },
    {
      title: "Smart Triaging",
      description: "Prioritizes threats based on risk scoring algorithms that consider asset value, vulnerability exposure, and potential business impact, ensuring analysts focus on what matters most."
    },
    {
      title: "Contextual Enrichment",
      description: "Automatically gathers and analyzes relevant information from internal and external sources to provide complete context around security events."
    },
    {
      title: "Adaptive Learning",
      description: "The system continuously learns from new threats and analyst feedback, improving its detection accuracy and investigation capabilities over time."
    },
    {
      title: "Predictive Threat Modeling",
      description: "Leverages advanced AI algorithms to predict potential attack vectors and vulnerabilities before they can be exploited, enabling proactive security posture management."
    },
    {
      title: "Automated Response Orchestration",
      description: "Intelligently coordinates and executes response actions across multiple security tools and platforms, ensuring rapid containment and remediation of identified threats."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Agentic <span className="text-spharaka-purple">AI Capabilities</span></h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our platform leverages true Agentic AI to transform security operations by streamlining complex 
            tasks that traditionally required human expertise and judgment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {agenticCapabilities.map((capability, index) => (
            <div 
              key={index} 
              className="bg-white p-6 rounded-xl border border-slate-200 hover:border-spharaka-purple transition-colors duration-300 shadow-sm"
            >
              <h3 className="text-xl font-semibold mb-2">{capability.title}</h3>
              <p className="text-gray-600">{capability.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AgenticCapabilitiesSection;
